import biModule from "./biModule"
import microstrategyView from "./microstrategyView.html"

biModule.config(["$stateProvider", ($stateProvider) => {
    $stateProvider.state("r2.bi", {
        url: "/bi",
        template: microstrategyView,
        controller: "microstrategyController",
        data: {
            pageTitle: "{{'title.report' | translate}}",
            group: "group.r2.kpi"
        },
        resolve: {
            isAllowed: ["$state", "permissionGroupSupportService", ($state, permissionGroupSupportService) => {
                return permissionGroupSupportService.isBiAllowed().then(function (isAllowed) {
                    if (!isAllowed) {
                        $state.go("r2.home")
                    }
                })
            }]
        }
    })
}])
